import { createApp } from 'vue';
import store from './store';
import axios from './axios';
import VueAxios from 'vue-axios';
// ================ TRANSLATION SERVICE : START ================= //
import i18n from './i18n';
// ================ TRANSLATION SERVICE : END ================= //
// ==================== COMPONENTS : START ======================= //
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';
// ==================== COMPONENTS : END ========================= //
// ==================== PAGES : START ======================= //
import LandingPage from './pages/LandingPage.vue';
import DashboardPage from './pages/DashboardPage.vue';
import WizardPage from './pages/WizardPage.vue';
import CookiesPage from './pages/CookiesPage.vue';
import ApplicationPage from './pages/ApplicationPage.vue';
import TodoPage from './pages/TodoPage.vue';
// ==================== PAGES : END ========================= //
import './assets/styles/app.scss';
import 'primevue/resources/primevue.min.css';
import 'bootstrap';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Tooltip from './helpers/tooltip/tooltip';
import customPrimeVueConfig from './primeVueConfig';
import ConfirmationService from 'primevue/confirmationservice';

import FontAwesomeIcon from './fontAwesome'

createApp({
    components: {
        AppHeader,
    },
    created() {
        // store.dispatch('loadTranslations');
        // store.dispatch('loadConfiguration');
    },
})
    .use(i18n)
    .use(store)
    .use(PrimeVue, {
        locale: customPrimeVueConfig,
    })
    .use(ToastService)
    .use(ConfirmationService)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#header');

createApp({
    components: {
        AppFooter,
    },
})
    .use(i18n)
    .use(store)
    .use(PrimeVue, {
        locale: customPrimeVueConfig,
    })
    .use(ToastService)
    .use(ConfirmationService)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#footer');

if (document.getElementById('app')) {
    const app = createApp({
        components: {
            LandingPage,
            DashboardPage,
            WizardPage,
            CookiesPage,
            ApplicationPage,
            TodoPage,
        },
        created() {
            // TODO: This should be deleted when session problems are resolved;
            // store.dispatch('keepSessionAlive');
        },
    });
    app.use(i18n);
    app.use(VueAxios, axios);
    app.use(store);
    app.use(PrimeVue, {
        locale: customPrimeVueConfig,
    });
    app.use(ToastService);
    app.use(ConfirmationService);
    app.component('font-awesome-icon', FontAwesomeIcon);
    app.directive('tooltip', Tooltip);
    app.directive('click-outside', {
        beforeMount: function (el, binding) {
            // Define ourClickEventHandler
            const ourClickEventHandler = (event) => {
                if (
                    !el.contains(event.target) &&
                    el !== event.target &&
                    !event.target.classList.contains('p-toast-icon-close-icon')
                ) {
                    // as we are attaching an click event listern to the document (below)
                    // ensure the events target is outside the element or a child of it
                    binding.value(event); // before binding it
                }
            };
            // attached the handler to the element so we can remove it later easily
            el.__vueClickEventHandler__ = ourClickEventHandler;

            // attaching ourClickEventHandler to a listener on the document here
            document.addEventListener('click', ourClickEventHandler, {
                capture: true,
            });
        },
        unmounted: function (el) {
            // Remove Event Listener
            document.removeEventListener('click', el.__vueClickEventHandler__, {
                capture: true,
            });
        },
    });
    app.mount('#app');
}
